<template>
  <section class="main">
    <div class="main-content">
      <v-headline class="main-headline">
        <div
          class="main-message uppercase"
          v-for="line of messageMap.message"
          :key="line"
        >
          <span>{{ line }}</span>
        </div>
      </v-headline>

      <v-link
        :class="{ hidden: isHiddenLinks }"
        :isLight="true"
        class="main-registration-link text-md"
        anchor="#form"
        >{{ dic.sectionMain.registration }}</v-link
      >
      <br />
      <v-link
        :class="{ hidden: isHiddenLinks }"
        class="main-learn-link text-t"
        anchor="#how"
        >{{ dic.sectionMain.knowMore }}</v-link
      >
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import VHeadline from '@/components/ui/VHeadline'
import VLink from '@/components/ui/VLink'

export default {
  name: 'TheMain',
  components: { VHeadline, VLink },
  computed: {
    ...mapGetters('main', {
      messageMap: 'getMessage',
      isHiddenLinks: 'isHiddenLinks',
    }),
    currentLang() {
      //this need for wake up store listner 
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner 
      return this.$store.state.main.dic
    },
  },
}
</script>

<style lang="scss" scoped>
.hidden {
  visibility: hidden;
}

.main {
  position: relative;
  background-image: url('../../assets/img/backgrounds/artboard.webp'),
    url('../../assets/img/backgrounds/artboard.jpg');
  background-size: cover;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  padding: 100px 0;
  box-sizing: border-box;
}

.main-content {
  margin: 40px 0;
  padding: 20px 0;
  width: 100%;
  text-align: center;
  align-self: center;
  vertical-align: center;
}

.main-headline {
  display: block;
  text-align: center;
}

.main-message {
  text-align: center;
  span {
    display: inline-block;
    padding: 10px 10px;
    margin: 10px 0;
    background-color: #facb0a;
    color: #020f39;
  }
}

.link {
  text-decoration: none;
}

.main-registration-link {
  margin: 10px 0;
  cursor: pointer;
  padding: 13px 20px;
  background-color: rgb(17, 55, 89);
  color: #ffffff;
  display: inline-block;
  border-radius: 3px;

  &:hover {
    background-color: rgba(17, 55, 89, 0.6);
    color: #000000;
  }
}

.main-learn-link {
  display: inline-block;
  color: #021759;
  margin-top: 30px;
}
</style>

<style lang="scss" scoped>
@media (max-width: 768px) {
}

@media (max-width: 375px), (max-width: 414px) {
  .main {
    padding: 100px 0 0 0;
  }
}
</style>
